import React, { useEffect, useState } from 'react'
import { Button, Form, Input, message, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { Option } from 'antd/es/mentions'
import { getRequestAuth, patchRequestForm, postRequest, postRequestForm } from '../../../request/request'
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors'

interface Props {
  isModalOpen: boolean
  setIsModalOpen: (e: boolean) => void
  clearForm: boolean
  regionDataLoading: boolean
  setReload: any
  editData: any
  regionData: any[] | null
  typeModal?: string | undefined | null
}

const AddingHuntingGrounds: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  typeModal,
  editData,
  regionData,
  setReload,
  regionDataLoading,
}) => {
  const { t } = useTranslation()
  const [add] = Form.useForm()
  const [loading, setLoading] = useState<boolean>(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [inputError, setInputError] = useState(false)
  let timeOut: any

  useEffect(() => {
    if (!editData) {
      return;
    }
    const {title, region } = editData;
    add.setFieldsValue({ title, region: region ? String(region) : null });
  })

  const modalTitle = () => {
    switch (typeModal) {
      case 'add':
        return t('h221')
      case 'edit':
        return `${t('h156')}: ${editData?.title || '-'}`
      default:
        return `${t('h157')}: ${editData?.title || '-'}`
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    timeOut = setTimeout(() => {
      add.resetFields()
      setValidateErrors({})
      setLoading(false)
    }, 200)
  }

  const handleFinish = async (values: any) => {
    if (typeModal === 'add') {
      postRequest('/trophy_book/hunting_farm', values)
        .then(() => {
          setLoading(false)
          message.success(t('h80'))
          setReload((prev: boolean) => !prev)
          handleCancel()
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data, setValidateErrors)
        })
    }
    if (!editData?.id) {
      return;
    }
    if (typeModal === 'edit') {
      patchRequestForm(`/trophy_book/hunting_farm/${editData.id}`, values)
       .then(() => {
          setLoading(false)
          message.success(t('h80'))
          setReload((prev: boolean) => !prev)
          handleCancel()
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data, setValidateErrors)
        })
    }
  }

  return (
    <Modal title={modalTitle()} width={900} open={isModalOpen} onCancel={handleCancel} className="ptb-0" footer={false}>
      <Form
        name="add"
        form={add}
        autoComplete="off"
        onFinish={handleFinish}
        layout="vertical"
        style={{
          padding: '24px 32px',
        }}
      >
        <Form.Item
          name="title"
          label={t('h153')}
          validateStatus={validateErrors?.title ? 'error' : ''}
          help={validateErrors?.title}
          rules={[{ required: true, message: t('h108') }]}
        >
          <Input placeholder={t('h222')}/>
        </Form.Item>

        <Form.Item
          name="region"
          label={t('h154')}
          rules={[{ required: true, message: t('h155') }]}
          validateStatus={validateErrors?.region ? 'error' : ''}
          help={validateErrors?.region}
        >
          <Select placeholder={t('h155')} allowClear loading={regionDataLoading}>
            {regionData?.map(({ id, region_name }: { id: number; region_name: string }) => (
              <React.Fragment key={id}>
                <Option value={String(id)}>{region_name}</Option>
              </React.Fragment>
            ))}
          </Select>
        </Form.Item>

        <div className="text-center">
          <Button
            key="submit"
            htmlType="submit"
            type="primary"
            loading={loading}
            style={{ backgroundColor: '#4A552E', borderColor: '#4A552E', boxShadow: '0 1px 4px 1px #E8EDE9' }}
          >
            {typeModal === 'add' ? t('h188') : t('h60')}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default AddingHuntingGrounds
